import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as WarningBlue } from 'assets/icons/warning-blue.svg';
import { ReactComponent as CheckIconGreen } from 'assets/icons/check_icon_green.svg';
import { Modal, TextAreaField, Label } from 'components';
import { Button } from 'antd';
import {
  outcomes,
} from 'utils';
// import { radioOptions, radioOptionsBeneficiaryObjection } from './utils';
import { updateFormField } from 'store/forms/actions';
import { Radio } from 'antd';
import isEmpty from 'lodash/isEmpty';

const SubmitModal = ({
  isVisible,
  setIsVisible,
  handleSubmit,
  submitDisabled,
  formKey,
  outcome,
  businessKey,
  setVisibleSubmit,
}) => {

  const renderContent = () => {
        return (
          <div>
            <div className="content-title color-purple-1 font-size-24 mb-2">
              Υποβολή Αίτησης
            </div>
            Πρόκειται να εγκρίνετε την αίτηση. Παρακαλούμε επιβεβαιώστε την ενέργεια διαφορετικά
            επιλέξτε Ακύρωση.

            <div className="register-buttons mt-2">
                <Button
                    className="return-button mt-3"
                    type="secondary"
                    disabled={false}
                    onClick={() => setVisibleSubmit(false)}
                >
                    Ακύρωση
                </Button>
                <Button
                    type="primary"
                    className="submit-login mt-3"
                    disabled={false}
                    onClick={submit}
                    id="inputEnter"
                >
                    Έγκριση
                </Button>
            </div>
          </div>
        );
}

  const submit = () => {
    setIsVisible(false);
    handleSubmit(true);
  };

  return (
    <>
      <Modal
        isVisible={isVisible}
        handleCancel={() => {
          setIsVisible(false);
        }}
        handleConfirm={submit}
        cancelText={'Ακύρωση'}
        okText={'Επιβεβαίωση'}
        submitDisabled={false}
        formKey={formKey}
        Icon={CheckIconGreen}
        outcome={outcome}
        className={'success-modal no-border'}
        footer={null}
        closable={false}
      >
        <div className="modal-submit-content">{renderContent()}</div>
      </Modal>
    </>
  );
};

export default SubmitModal;
